// 新闻内容的枚举
export enum NewsContentType {
  Text = 0, // 文本
  Image = 1, // 图片
  EmptyLine = 2, // 空行
}
